"use client"

import { TypeProduct } from '@/lib/redux/features/product/type'
import ProductItem from '../../Category/Products/ProductItem'
import { TypeCategory, TypeStoreDetail } from '@/lib/redux/features/store/type'

type CategoryProductsItemCSRProps = {
  category?: TypeCategory,
  customGridProducts?: number,
  cacheData?: boolean,
  store: TypeStoreDetail,
  products: TypeProduct[]
}


const CategoryProductsItemCSR = ({ store: storeData, products, ...props }: CategoryProductsItemCSRProps) => {

  return (
    <>
      {products
        .map((product: TypeProduct) => {
          return (
            <ProductItem store={storeData} customGridProduct={props.customGridProducts || (!!props.category ? storeData.products_per_category_section || 5 : undefined)} product={product} key={product.id} />
          )
        })}
    </>
  )
}

export default CategoryProductsItemCSR